import { format } from 'date-fns'
import { ru as ruDateLocale, enUS as enDateLocale } from 'date-fns/locale'
import { Locale } from 'date-fns'
import i18n from 'i18n'

const dateFnsLocales: Record<string, Locale> = {
  ru: ruDateLocale,
  en: enDateLocale,
}

export const formatDate = (date: Date | string, formatString: string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  const currentLanguage = i18n.language || 'ru'
  const locale = dateFnsLocales[currentLanguage] || ruDateLocale

  return format(dateObj, formatString, { locale })
}

export const getDateLocale = (): Locale => {
  const currentLanguage = i18n.language || 'ru'
  return dateFnsLocales[currentLanguage] || ruDateLocale
}
